<template>
  <div id="success">
    <div
      class="base-form"
      :class="formProps.formClass"
      id="page-form"
      v-if="!isSuccess"
    >
      <h3 class="base-form-title" v-if="formProps.title">
        {{ formProps.title }}
      </h3>
      <div class="base-form-text" v-html="formProps.text"></div>
      <form class="form" novalidate="true">
        <slot></slot>
        <div
          class="base-form-submit"
        >
          <input
            type="button"
            class="pl-form-submit"
            value="Submit"
            @click="$emit('submit')"
          />
          <div class="base-form-submit-info">
              Fields marked with an asterisk (*) are mandatory
          </div>
        </div>
        <div class="pl-form-row">
          <div class="page-validation-message">
            <div
              class="form-validation page-validation"
              v-if="pageValidationMessage"
              v-html="pageValidationMessageText.length > 0 ? pageValidationMessageText : 'To submit, please fill the required fields marked above'"
            >
              
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="loading-overlay" v-if="isLoading">
      <div class="loading-overlay-spinner"></div>
    </div>
    <div class="submit-success" v-if="isSuccess" ref="submitSuccess">
      <div class="submit-success-icon">
        <img src="/img/icon-sucess.svg" alt="sucess" />
      </div>
      <div
        class="submit-success-text"
        v-html="formProps.thank"
      ></div>
    </div>
  </div>
</template>
<script>
import {formMixin} from '@/mixins/formMixin'
export default {
  name: "basic-form",
  mixins: [formMixin],
  props: {
    formProps: Object,
    success: Boolean,
    loading: Boolean,
    pvm: Boolean,
    pvmText: String
  },
  watch: {
    success() {
      this.isSuccess = this.success;
      if (this.isSuccess) {
        setTimeout(() => {
          this.$refs.submitSuccess.scrollIntoView({
            block: "start",
            behavior: "smooth",
          });
        }, 1);
      }
    },
    loading() {
      this.isLoading = this.loading;
    },
    pvm() {
      this.pageValidationMessage = this.pvm;
    },
    pvmText() {
      this.pageValidationMessageText = this.pvmText;
    },
  },
  data() {
    return {
      isSuccess: false,
      isLoading: false,
      pageValidationMessage: false,
      pageValidationMessageText: ''
    };
  }
};
</script>
